const ITEMS = [
  { text: "GARAGE CLEANOUTS", strong: true },
  { text: "PALM BAY & MELBOURNE", strong: false },
  { text: "FURNITURE REMOVAL", strong: true },
  { text: "COMMERCIAL PROPERTY TURNOVERS", strong: false },
  { text: "YARD DEBRIS", strong: true },
  { text: "SAME-DAY DISPATCH", strong: false },
  { text: "ESTATE & HOARDING CLEANOUTS", strong: true },
  { text: "CALL (321) 420-2707", strong: false },
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="border-y border-white/10 bg-zinc-950 py-3 overflow-hidden" data-testid="marquee-ribbon">
      <div className="flex whitespace-nowrap marquee-track text-xs font-mono uppercase tracking-widest text-zinc-400 w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className={`mx-6 ${item.strong ? "text-white font-bold" : ""}`}>{item.text}</span>
            <span>/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
